import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import {
  getEddyUiCopy,
  institutionShortName,
  programmeDisplayName
} from './eddyBetaUi';

function ChatRecommendationCards({ programmes, onSelect, language = 'en' }) {
  if (!programmes?.length) return null;
  const copy = getEddyUiCopy(language);

  return (
    <div className="mt-4 border-t border-edge pt-4">
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-link">{copy.programmeResults}</p>
          <p className="mt-1 text-xs text-ink-subtle">{copy.identifiedData}</p>
        </div>
        <span className="rounded-full border border-edge bg-surface-muted px-2.5 py-1 text-[10px] font-semibold text-ink-subtle">{programmes.length} {programmes.length === 1 ? copy.result : copy.results}</span>
      </div>

      <div className="grid gap-2.5 sm:grid-cols-2">
        {programmes.map((programme) => {
          const displayedName = programmeDisplayName(programme, language);
          const overview = programme.sections?.overview || {};
          return (
          <article key={programme.programmeCode} className="rounded-2xl border border-edge bg-surface-muted/55 p-3.5">
            <div className="flex items-start justify-between gap-3">
              <div className="flex h-8 min-w-8 items-center justify-center rounded-lg bg-primary px-2 text-[10px] font-bold text-primary-foreground">{institutionShortName(programme.institution || overview.institution)}</div>
              <span className="rounded-full border border-edge bg-surface px-2 py-0.5 text-[9px] font-semibold text-ink-subtle">{programme.programmeCode}</span>
            </div>
            <h3 className="mt-3 text-xs font-semibold leading-snug text-ink">{displayedName}</h3>
            <p className="mt-2 text-[10px] leading-relaxed text-ink-muted">{overview.description || programme.institution || overview.institution}</p>
            {programme.admissionYear ? <p className="mt-2 text-[9px] font-semibold uppercase tracking-wider text-ink-subtle">{programme.admissionYear} · {programme.matchType?.replaceAll('_', ' ') || copy.programmeResults}</p> : null}
            <button type="button" onClick={() => onSelect(programme)} className="mt-3 flex w-full items-center justify-between rounded-xl border border-edge bg-surface px-3 py-2 text-[10px] font-semibold text-ink transition hover:border-link/30 hover:text-link">{copy.viewProgramme} <FiChevronRight aria-hidden /></button>
          </article>
          );
        })}
      </div>
    </div>
  );
}

export default ChatRecommendationCards;
